import React, { Component, PropTypes } from 'react'
import md5 from 'md5'
import { surplusTime,postPromise, createUrl } from '../../common/utils'
import { ONECLOUD_API_HOST } from '../../common/consts'
import CountUp from 'react-countup'
import t from '../../i18n/purchase'

export class SubmitSection extends Component {
	constructor(props){
		super(props)
	}

	btnRender(){
		const { status,onSubmit,constStatus,ifShowLoading } = this.props;
		if(status===constStatus){
			return <a href="javascript:;" className="btn-oc" onClick={onSubmit}>{t('submit_order')}{ifShowLoading?<i className="i-oc-loading"></i>:null}</a>
		}else {
			return <a href="javascript:;" className="btn-oc btn-oc-disable">{t('submit_order')}</a>
		}
	}
	render(){
		return <div className="oc-bot-sum">
			{this.btnRender()}
			{t('price_presalle')}
			<p>{t('tips_presell_deliver')}</p>
		</div>
	}
}
export class DepositHeaderSection extends Component {
	render() {
		return <div className="oc-buy-ban">
			<div className="oc-buy-banner">
				<h2>{t('banner_title')}</h2>
				<h3>{t('presell_ing')}</h3>
				<img className="presell-ban-img" src="//static.onethingcloud.com/images/presell/ban.jpg" alt={t('wky')} />
			</div>
		</div>
	}
}

export class DepositRulesSection extends Component {
	render() {
		return <div className="oc-buy-aside">
					{t('deposit_rules')}
            </div>
	}
}

export function PurchaseHeader(props) {
	const { title, isSingleBlue } = props
	return (
		<div className="oc-buy-ban">
		    <div className="oc-buy-banner">
		        <h2>{title}</h2>
                {props.hideTxt ? null : <h3>{t('banner_subtitle')}</h3>}
		        {props.userTotal && window.LANG!='hk' ? <p className="oc-buy-price-num">{t('deposit_number1')}<em> <CountUp start={10000} end={props.userTotal} duration={1} /> </em>{t('deposit_number2')}</p> : null}
			{
				isSingleBlue ?
				<div className="i-banbox">
					<i className="i-ban-wky-fj"></i>
				</div> :
				<div className="i-banbox">
					<i className="i-ban-wky3"></i>
					<i className="i-ban-wky2"></i>
					<i className="i-ban-wky1"></i>
				</div>
			}					
		    </div>
		</div>
	)
}
PurchaseHeader.defaultProps = {
	title: t('banner_title'),
	isSingleBlue: false
}

export class VerifyCode extends Component {
	constructor(props){
		super(props)
		this.vcodeChangeOnComponent = this.vcodeChangeOnComponent.bind(this)
		this.onKeyDown = this.onKeyDown.bind(this)
		this.refreshVerifyCode = this.refreshVerifyCode.bind(this)
	}
	componentDidMount(){
		this.refs.inputElm.focus()
	}
	vcodeChangeOnComponent(e){
		const value = e.target.value
		const {onChange} = this.props;
		onChange(value)
	}
	onKeyDown (e) {
		const { submitVcode} = this.props
		const keyCode = e.keyCode
		if(keyCode==13) submitVcode()
	}

	refreshVerifyCode(e){
		e.preventDefault()
		this.props.refreshVerifyCode && this.props.refreshVerifyCode()
	}

	render () {
		const {
			onClose,
			onChange,
			submitVcode,
			vcodeIsError,
			vcodeIsEmpty,
			inputValue,
			vcodeString
		} = this.props
		let quesboxStyle = {
			height: 'auto',
			marginBottom: '10px'
		}
		
		return (
		<div className="oc-pop" style={{zIndex: 999,position: 'absolute'}}>
				<div className="oc-pop-wp">
					<div className="oc-pop-textbox oc-tb">
						<div className="oc-pop-text oc-tb-cell">
							<h3>{t('verify_input')} <a href="javascript:;" className="oc-quesbox-refresh" onClick={this.refreshVerifyCode}><i className="i-oc-refresh"></i>{t('verify_refresh')}</a></h3>
							<h4>{t('verify_yellow')}</h4>
							<h4>{vcodeIsError?<span style={{color:'red'}} >{t('verify_error')}</span>:null}</h4>
							<div className="oc-quesbox" 
								ref="vcodeResElem" 
								dangerouslySetInnerHTML={vcodeString}
								style={quesboxStyle}>
                			</div>
							<div className="oc-u-inpbox oc-ques-inp">
								<input ref="inputElm"
									className="oc-inptxt" 
									type="text" 
									placeholder={t('verify_empty')} 
									value={inputValue} 
									onKeyDown={this.onKeyDown}
									onChange={this.vcodeChangeOnComponent} />
								{vcodeIsEmpty ? <p className="oc-err" >{t('verify_empty')}</p> : null}
							</div>
						</div>
					</div>
					<div className="oc-pop-btnbox">
						<a href="javascript:;" className="btn-oc" onClick={submitVcode}>{t('ok')}</a>
					</div>
					<a href="javascript:;" className="oc-pop-close" onClick={onClose}>{t('close')}</a>
				</div>
			</div>
			)
	}

}


/**
 * 消息弹窗
 * 
 * @export
 * @class TipPop
 * @extends {Component}
 * msg——弹窗主体内容，支持html元素
 * jump—— 如果存在，并为函数，则点击执行自定义函数
 * 		  如果存在，并且为字符串，则点击跳转到自定义链接
 * 		  其他情况，默认确认按钮为关闭弹窗
 * onClose——如果为函数，则为关闭弹窗的回调函数
 * 			如果为false，则不设置确认按钮和关闭按钮
 * btnTxt——按钮文字 
 * 
 */
export class TipPop extends Component {
	constructor(props){
		super(props)
		this.btnRender = this.btnRender.bind(this)
	}

	btnRender(){
		const {jump,onClose,btnTxt} = this.props;
		let jumpType = jump && typeof jump ;
		let noBtnRender = ()=>{
			return <div className="oc-pop-btnbox"></div>
		}
		let btnRenderInner = ()=>{
			let submitBtn = ()=>{
				if(jumpType=='function'){ 
					return <a href="javascript:;" className="btn-oc" onClick={jump}>{btnTxt}</a>
				}else if(jumpType=='string'){
					return <a href={jump} className="btn-oc">{btnTxt}</a>
				}else {
					return <a href="javascript:;" className="btn-oc" onClick={onClose}>{btnTxt}</a>
				}
			}
			return <div>
				<div className="oc-pop-btnbox">
					{submitBtn()}
				</div>
				<a href="javascript:;" className="oc-pop-close" onClick={onClose}>{t('close')}</a>
			</div>
		}
		return onClose ? btnRenderInner() : noBtnRender()
	}

	render() {
		const {msg, jump, onClose,btnTxt} = this.props;
		let dangerousInnerHTML = {
			__html: msg
		}
		return (
			<div className="oc-pop">
				<div className="oc-pop-wp">
					<div className="oc-pop-textbox oc-tb">
						<div className="oc-pop-text oc-tb-cell"
							dangerouslySetInnerHTML={dangerousInnerHTML}>
							
						</div>
					</div>
					{this.btnRender()}
				</div>
			</div>
		)
	}
}
TipPop.defaultProps = {
	msg: 'hello breeze',
	jump: '',
	onClose: ()=>console.log("this is a default func (●'◡'●)ﾉ♥"),
	btnTxt: '确定'
}

export class Countdown extends Component {
	render(){
		const { currTime, targetTime, desc } = this.props
		if(!currTime || !targetTime) return null
		const time = surplusTime(currTime, targetTime)
		return (
			<div className="oc-u-tit oc-u-tit-buytime">
			    <div className="oc-buytime">
			    <p>{desc}</p>
			        {time.day>0 ? <span><em>{time.day}</em>{t('date_day')}</span> : null}
			        <span><em>{time.hour}</em>{t('date_hour')}</span>
			        <span><em>{time.minute}</em>{t('date_minute')}</span>
			        <span><em>{time.second}</em>{t('date_second')}</span>
			    </div>
			</div>
		)		
	}
}
Countdown.propTypes = {
	currTime: PropTypes.instanceOf(Date).isRequired,
	targetTime: PropTypes.instanceOf(Date),
	type: PropTypes.string
}

export function PurchaseFlow(props){
	return t('buy_steps')
}

export function PurchaseRule(props){
	return null
	/*return (
		<dl className="oc-buy-aside-rule">
		    <dt>活动规则</dt>
		    <dd>1. 预付定金启动时间：9月26日10:00-12:00，2小时不限量预定开启；</dd>
		    <dd>2. 预定成功后享受购买资格，成功支付定金与尾款后，我们将在统一时间发货；请关注预定时间及尾款支付时间，建议您开启短信提醒，以免错过购买时间；</dd>
		    <dd>3. 预付定金在预定期间不可退，请确认后提交预定订单；</dd>
		    <dd>4. 预付统一发货时间：2018年1月15日，预付用户我们会为您的激活码自动延期；</dd>
		    <dd>5. 定金可直接抵扣商品总额，定金不支持优惠码抵扣，尾款可支持优惠码抵扣；</dd>
		    <dd>6. 查看预定订单请至“我的订单”-“我的预售”进行查看。</dd>
		</dl>
	)*/
}

export class ColorSelector extends Component {
	constructor(props){
		super(props)
		this.switchColor = this.switchColor.bind(this)
	}
	switchColor(e){
		this.props.onChange($(e.currentTarget).data('color'))
	}

	render(){
		const { colorConfig, currColor, showZeroColor } = this.props
		return (
			<dl className="oc-buy-color">
			    <dt>{t('colorcom_subtitle')}</dt>
			    {
			    	colorConfig.map(item => {
						let ret = null
						if (item.has) {
							ret = <dd className={currColor==item.color ? 'oc-selected' : ''} key={item.color} onClick={this.switchColor} data-color={item.color}>
								<i className={`i-oc-col-${item.color}`}></i>
								{item.text}
							</dd>
						} else if (showZeroColor) {
							ret = <dd className={'oc-buy-soldout'} key={item.color} data-color={item.color}>
								<i className={`i-oc-col-${item.color}`}></i>
								{item.text}{t('colorcom_zero')}
							</dd>
						}						
			    		return  ret
			    	})
			    }
			</dl>
		)
	}
}
ColorSelector.propTypes = {
	colorConfig: PropTypes.array.isRequired,
	currColor: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired
}
ColorSelector.defaultProps = {
	showZeroColor: true
}

export class DeliverDate extends Component {
	constructor(props){
		super(props)
		this.itemRender = this.itemRender.bind(this)
	}

	changeDate(item){
		let dateString = item['deliver_time']
		this.props.onChange(dateString)
	}

	itemRender(item,index){
		let {currDate,currColor} = this.props
		let dateString = item['deliver_time']
		return item.hasStatus
			? <dd onClick={this.changeDate.bind(this,item)} key={index} className={dateString==currDate ? 'oc-selected' : ''} >{dateString}</dd> 
			: <dd key={index} className="oc-buy-soldout">{dateString}</dd>
	}

	render(){
		const { dDateConfig, currDate,currColor } = this.props
		if(!dDateConfig || dDateConfig.length == 0) return null

		return (
			<dl className="oc-buy-color oc-buy-date">
			    <dt>{t('delivercom_subtitle')}</dt>
			    { dDateConfig.map((item,index)=> this.itemRender(item,index)) }
			</dl>
		)
	}
}
DeliverDate.defaultProps = {
	dDateConfig: [],
	currDate: null,
	currColor: '',
	onChange: ()=>console.log('this is a default func')
}

export class ImageCode extends Component {
	constructor(props){
		super(props)
		this.state = {
			imgCode: null,
			imgCodeUrl: '/images/purchase/loading.gif',
			errMsg: null
		}
		this.changeImgCode = this.changeImgCode.bind(this)
		this.handleImgCodeChange = this.handleImgCodeChange.bind(this)
	}

	componentDidMount(){
		this.changeImgCode()
	}

	changeImgCode(e){
		const url = `//verify-img-content.onethingcloud.com/imgcode/refresh.php?type=0&_=${(new Date()).getTime()}&uniqueKey=${md5(getCookie('phone'))}`					
		const img = new Image()
		img.src = url
		img.onload = () => {
		    this.setState({ imgCodeUrl:url })                                            
		}
	}

	handleImgCodeChange(e){
		const value = e.target.value
		this.setState({ imgCode: value })
		this.props.onChange(value)
	}

	render(){
		const { colorConfig, currColor } = this.props
		return (
			<div className="oc-buy-code">
			    <span className="oc-buy-code-name">{t('imagecode_title')}</span>
			    <div className="oc-buy-code-img">
			        <input className="oc-inptxt" type="text" placeholder={t('imagecode_input')} maxLength="5" value={this.state.imgCode} onChange={this.handleImgCodeChange} />
			        <span className="oc-inp-codeimg">
			        	<img src={this.state.imgCodeUrl} onClick={this.changeImgCode} />
			        </span>
			    </div>
			    <p className="oc-err">{this.state.errMsg}</p>
			</div>
		)
	}
}
ImageCode.propTypes = {
	onChange: PropTypes.func.isRequired
}

/**
 * 	viewHandler——不同的错误码进行不同的视图操作
	successHandler——iRet为0的处理函数
	commonHandler——所有错误码都会执行的回调
	otherResHandler——其他错误码的回调执行方法
	someResCodeMap——错误码以及相对应viewHandler需要的参数
	example:	{
		11: {
			content: 'xxxx',
			link:'',
			okBtn: '知道了'
		},
		4015: {
			content: 'xxxx',
			link: '/usercenter.html',
			okBtn: '确定'
		}
	}
	respone——接口返回的参数
 */
export class handlerResponeInDone {
    constructor(props) {
		let f = ()=>{};
		this.viewHandler = props.viewHandler;
		this.successHandler = props.successHandler;
		this.otherResHandler = props.otherResHandler;
		this.someResCodeMap = props.someResCodeMap;
		this.commonHandler = props.commonHandler||f;
		this.respone = props.respone;
    }
    render(){
		const respone = this.respone;
		const resCode = respone.iRet;
		const someResCodeMap = this.someResCodeMap
		if(resCode===0){
			this.successHandler(respone);
		}else if(someResCodeMap[resCode]){
			let [...params] = [
					someResCodeMap[resCode]['content']||'default content',
					someResCodeMap[resCode]['link']||'',
					someResCodeMap[resCode]['okBtn']|| t('ok')
				]
			this.viewHandler(...params)
		}else {
			this.otherResHandler(respone)
		}
		this.commonHandler(respone)
	}
}

export function getSomeResCodeMap (){
	let normalError = {
			'30006' : t('rtncode_30006'), 
			'30008' : t('rtncode_30008'),
			'30009' : t('rtncode_30009'),
			'30003' : t('rtncode_30003'),
			'30106' : t('rtncode_30106'),
			'-2' : t('rtncode__2'),
			'-2004': t('rtncode__2004'),
			'-2000': t('rtncode__2000'),
			'-1003': t('rtncode__1003'),
			'-5': t('rtncode__5'),
	
			"41006": t('rtncode_41006'),
			"41007": t('rtncode_41007'),
			"41009": t('rtncode_41009'),
			"41013": t('rtncode_41013'),
			"41014": t('rtncode_41014'),
			'41016': t('rtncode_41016'),
			
			41008: t('rtncode_41008'),
			'-301': t('rtncode__301'),
			30032: t('rtncode_30032'),
			41011: t('rtncode_41011'),
			'-1': t('rtncode__1')
		};
	let specialError = {
			41010: {
				content: t('rtncode_41010'),
				link: createUrl('html/usercenter'),
				okBtn: t('check_order')
			},
			30005 : {
				content: t('rtncode_30005')
			},
			30016 : {
				content: t('rtncode_30016'),
				okBtn: t('tips_continue')
			},
			30025 : {
				content: t('rtncode_30025'),
				okBtn: t('tips_continue')
			},
			30026 : {
				content: t('rtncode_30026'),
				okBtn: t('tips_continue')
			},
			30007: {
				content : t('rtncode_30007'),
				link: createUrl('html/usercenter'),
				okBtn: t('check_order')
			}
		};
	function wrapObject(object){
		let rtn={};
		for(let key in object){
			rtn[key] = {
				content: object[key]
			}
		}
		return rtn;
	}
	return $.extend({},wrapObject(normalError),specialError)
}


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components.js